import { Link } from "react-router-dom";
import { IMG } from "@/lib/data";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="relative bg-obsidian text-bone noise-overlay overflow-hidden">
      <div className="relative mx-auto max-w-[1600px] px-6 md:px-10 lg:px-14 py-24 md:py-32">
        {/* Brand mark */}
        <div className="mb-20 md:mb-24 flex justify-center">
          <img
            src={IMG.logoBone}
            alt="Hideaway Cattle Co. — Stevensville, Montana"
            className="w-[220px] md:w-[280px] h-auto"
            loading="lazy"
          />
        </div>

        <div className="grid grid-cols-12 gap-y-16 gap-x-8">
          {/* Wordmark */}
          <div className="col-span-12 md:col-span-6">
            <p className="font-mono text-[11px] tracking-overline uppercase text-limestone">
              — Estate
            </p>
            <h3 className="mt-5 font-serif text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
              Hideaway
              <br />
              <span className="italic text-limestone">Cattle Company</span>
            </h3>
            <p className="mt-8 max-w-md text-limestone/90 leading-relaxed">
              Registered Black Angus & Charolais seedstock, bulls
              and replacement heifers, born under the Bitterroot skyline. A small program built on
              maternal integrity, disposition, and phenotype.
            </p>
          </div>

          {/* Contact */}
          <div className="col-span-12 md:col-span-3">
            <p className="font-mono text-[11px] tracking-overline uppercase text-limestone">
              — Contact
            </p>
            <ul className="mt-6 space-y-3 text-bone/90 font-sans text-[15px]">
              <li>John &amp; Jennifer Quinn</li>
              <li className="text-limestone">
                <a
                  href="tel:+19167198522"
                  className="hover:text-terracotta transition-colors"
                >
                  916.719.8522
                </a>
                <br />
                <a
                  href="mailto:hideawaycattle@gmail.com"
                  className="hover:text-terracotta transition-colors"
                >
                  hideawaycattle@gmail.com
                </a>
              </li>
              <li className="text-limestone">
                3606 Bridle Bit Lane
                <br />
                Stevensville, MT 59870
              </li>
            </ul>
          </div>

          {/* Nav */}
          <div className="col-span-12 md:col-span-3">
            <p className="font-mono text-[11px] tracking-overline uppercase text-limestone">
              — Index
            </p>
            <ul className="mt-6 space-y-3 text-bone/90 font-sans text-[15px]">
              {[
                ["/about", "About"],
                ["/herd", "Our Herd"],
                ["/bulls", "Bulls"],
                ["/heifers", "Heifers"],
                ["/contact", "Contact"],
              ].map(([href, label]) => (
                <li key={href}>
                  <Link
                    to={href}
                    className="inline-flex items-center gap-3 text-bone hover:text-terracotta transition-colors group"
                  >
                    <span
                      aria-hidden
                      className="h-px w-6 bg-limestone group-hover:w-10 group-hover:bg-terracotta transition-all"
                    />
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-24 pt-8 border-t border-bone/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 font-mono text-[11px] tracking-overline uppercase text-limestone">
          <span>© {year} Hideaway Cattle Co. All rights reserved.</span>
          <span>Bitterroot Valley · MT · U.S.A.</span>
        </div>

        {/* Oversized decorative mark */}
        <div
          aria-hidden
          className="pointer-events-none select-none absolute -bottom-16 md:-bottom-24 -right-6 md:-right-10 font-serif text-[28vw] leading-none text-bone/[0.04] tracking-tighter"
        >
          Hideaway
        </div>
      </div>
    </footer>
  );
}
